<template>
  <div class="side">
    <div class="side-block">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              ref="menuBtn"
            >
              <p>Уровни</p>
              <img
                class="lesson-arr"
                src="../../assets/images/lesson/arrow-end.svg"
                alt=""
              />
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse side-accord collapse show"
            data-bs-parent="#accordionExample"
            ref="menu"
          >
            <div class="accordion-body side-levels">
              <template
                v-for="(levelItem) in levelList"
                :key="levelItem.level_mark"
              >
                <a
                  :href="'/level/' + levelItem.level_mark"
                  ref="levels"
                  class="side-level side-level--succes"
                  :class="[
                    levelId === levelItem.level_mark &&
                      'side-level--active',
                  ]"
                >
                  <div class="side-level-item">
                    <div class="side-level-img">
                      <template
                        v-if="levelItem.level_mark === lastAvailableLevelMark"
                      >
                        <img
                          src="../../assets/images/lesson/bg-white.svg"
                          alt=""
                        />
                      </template>
                      <template v-else-if="levelItem.available">
                        <img
                          src="../../assets/images/lesson/bg-green.svg"
                          alt=""
                        />
                      </template>
                      <template v-else>
                        <img
                          class="hidden"
                          src="../../assets/images/lesson/bg-zamok.svg"
                          alt=""
                        />
                      </template>
                    </div>
                    <div class="side-level-text">{{ levelItem.name }}</div>
                  </div>
                </a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showBanner" class="side-banner">
      <div class="side-banner-text">Учите английский легко</div>
      <div class="side-banner-img">
        <img src="../../assets/images/lesson/banner.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import levelClient from "@/client/level";

export default {
  props: {
    levelId: Number,
    minHeight: Number,
    showBanner: Boolean,
  },
  data() {
    return {
      levelList: [],
      lastAvailableLevelMark: 0,
      lastAvailableLevelIdx: 0,
      itemRefs: [],
      windowWidth: window.innerWidth,
      menuClosed: false,
    };
  },
  mounted() {
    this.itemRefs = [];

    if (this.levelId > -1) {
      levelClient.LevelGetList((levels) => {
        this.levelList = levels;

        for (let i in levels) {
          if (levels[i].available) {
            this.lastAvailableLevelMark = levels[i].level_mark;
            this.lastAvailableLevelIdx = i;
          }
        }

        this.scrollToActiveLevel();
      });

      window.addEventListener("resize", this.updateWindowWidth);
      this.updateWindowWidth();
    }

    this.$watch(
        () => this.levelId,
        (newId, oldId) => {
          if (newId > 0) {
            levelClient.LevelGetList((levels) => {
              this.levelList = levels;

              for (let i in levels) {
                if (levels[i].available) {
                  this.lastAvailableLevelMark = levels[i].level_mark;
                  this.lastAvailableLevelIdx = i;
                }
              }

              this.scrollToActiveLevel();
            });

            window.addEventListener("resize", this.updateWindowWidth);
            this.updateWindowWidth();
          }
        }
    )
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  methods: {
    scrollToActiveLevel() {
      this.$nextTick(() => {
        const activeLevel = this.$refs.levels.find((level) =>
            level.classList.contains("side-level--active")
        );
        const menuContainer = this.$refs.menu;

        if (activeLevel && menuContainer) {
          menuContainer.scrollTo({
            top: activeLevel.offsetTop - menuContainer.offsetTop - 30,
            behavior: "smooth",
          });
        }
      });
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < this.minHeight && !this.menuClosed) {
        this.closeMenu();
      } else if (this.windowWidth >= this.minHeight && this.menuClosed) {
        this.openMenu();
      }
    },
    closeMenu() {
      const menu = this.$refs.menu;
      if (menu) {
        menu.classList.remove("show");
      }
      const menuBtn = this.$refs.menuBtn;
      if (menuBtn) {
        menuBtn.classList.add("collapsed");
      }
      this.menuClosed = true;
    },
    openMenu() {
      const menu = this.$refs.menu;
      if (menu) {
        menu.classList.add("show");
      }
      const menuBtn = this.$refs.menuBtn;
      if (menuBtn) {
        menuBtn.classList.remove("collapsed");
      }
      this.menuClosed = false;
    },
  },
};
</script>

<style scoped>
/* Add specific styles here if needed */
</style>